<template>
  <div class="box">
    <admin-box-item title="예약 마감시간" subtitle="예약을 몇시간 전까지 받을 지 설정합니다.">
      <admin-form-item label="예약 마감시간">
        <div class="txt-deadline">일정 시작시간
          <input class="input-border" type="number" v-model.number="reservePolicy.deadline_time"> 시간 전까지 예약가능</div>
      </admin-form-item>
    </admin-box-item>
  </div>
</template>

<script>
  export default {
    name: "PanelReserveDeadline",
    props: {
      reservePolicy: {
        type: Object
      }
    },
    data() {
      return {
        deadline: 1
      }
    }
  }
</script>

<style lang="stylus" scoped>
  .txt-deadline
    font-size 13px
    color #787878
  input
    width 40px
    margin 0 4px 0 16px
</style>
